import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './components/auth/auth.module';
import { ShoppingCartComponent } from './components/shopping-cart/shopping-cart.component';
import { AddTokensComponent } from './components/wallet/add-tokens/add-tokens.component';
import { EnterOtpComponent } from './components/wallet/enter-otp/enter-otp.component';
import { Interceptor } from './core/interceptor/interceptor';
import { LoggedLayoutComponent, SharedModule } from './shared';
import { GestureConfig } from '@angular/material';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { ConnectionServiceModule } from 'ng-connection-service';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LoginComponent } from './components/login/login.component';
import { JoinnowComponent } from './components/joinnow/joinnow.component';
import {LeminCroppedCaptchaModule} from "@leminnow/ng-lemin-cropped-captcha";
// import { CancelUploadingComponent } from './components/all-modals/cancel-uploading/cancel-uploading.component';
const dbConfig: DBConfig = {
  name: 'MyDb',
  version: 3,
  objectStoresMeta: [{
    store: 'notification_users',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'user_id', keypath: 'user_id', options: { unique: false } },
      { name: 'username', keypath: 'username', options: { unique: false } },
      { name: 'name', keypath: 'name', options: { unique: false } },
      { name: 'email', keypath: 'email', options: { unique: false } },
      { name: 'avatar', keypath: 'avatar', options: { unique: false } },
      { name: 'chat_sku', keypath: 'chat_sku', options: { unique: false } }
    ]
  }]
};

@NgModule({
  declarations: [
    AppComponent,
    LoggedLayoutComponent,
    ShoppingCartComponent,
    EnterOtpComponent,
    AddTokensComponent,
    //SupportComponent,
    // AccountComponent,
    // AddAudioVideoModalComponent
    LoginComponent,
    JoinnowComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    SharedModule,
    AuthModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    TabsModule.forRoot(),
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AngularMultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    ConnectionServiceModule,
    CarouselModule,
    LeminCroppedCaptchaModule
  ],
  entryComponents: [
    ShoppingCartComponent,
    EnterOtpComponent,
    AddTokensComponent,
    // CancelUploadingComponent
  ],
  providers: [
    NgbActiveModal,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    DatePipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
